// extracted by mini-css-extract-plugin
export var cartIcon = "_kx-0";
export var cartIconContainer = "_kx-1";